import React from "react";
import { Account } from "shared/types/authorization";
import { useStyles } from "./AccountList.styles";
import SalesforceLogoUrl from 'assets/images/salesforce-logo-mini.svg';
import HubspotLogoUrl from 'assets/images/hubspot-logo-mini.svg';
import { AccountType } from "shared/types/flowstep";
import { IconButton, TooltipHost } from "@fluentui/react";

const accountLogos = {
  [AccountType.SF]: SalesforceLogoUrl,
  [AccountType.HS]: HubspotLogoUrl,
}

interface AccountListProps {
  accounts: Account[];
  currentAccount: Account | null;
  onAccountClick: (account: Account) => void;
  onRemoveAccountClick: (account: Account) => void;
}

export const AccountList: React.FC<AccountListProps> = (props) => {
  const { accounts, currentAccount, onAccountClick, onRemoveAccountClick } = props;
  const styles = useStyles();


  const renderLoginInfo = (account: Account, isCurrent: boolean) => {
    if (account.loginData.accountType === AccountType.SF) {
      return (
        <div className={styles.loginInfo}>
          <div className='name'>
            {account.loginData.username}{isCurrent ? ' (current)' : ''}
          </div>
          <div className='providerName'>
            {account.loginData.sfMode === 'sandbox' ? 'Salesforce (sandbox)' : 'Salesforce'}
          </div>
        </div>
      )
    }

    if (account.loginData.accountType === AccountType.HS) {
      const [userName, hubDomain] = account.loginData.username.split(':');

      return (
        <div className={styles.loginInfo}>
          <div className='name'>
            {userName}{isCurrent ? ' (current)' : ''}
          </div>
          {hubDomain && (
            <div className='providerName'>
              {hubDomain}
            </div>
          )}
          <div className='providerName'>
            Hubspot
          </div>
        </div>
      )
    }
  }

  return (
    <div className={styles.accountList}>
      {accounts.map((account) => {
        const isCurrent = account.username === currentAccount?.username;
        return (
          <div
            key={account.loginData.username}
            className={`${styles.account} ${isCurrent ? styles.accountActive : ''}`}
            onClick={() => { !isCurrent && onAccountClick(account) }}
          >
            <div className='providerLogo'>
              {accountLogos[account.loginData.accountType] && (
                <img src={accountLogos[account.loginData.accountType]} width={22} height={22} />
              )}
            </div>
            {renderLoginInfo(account, isCurrent)}
            <TooltipHost content={isCurrent ? 'Log Out' : 'Forget'} hostClassName='removeButtonContainer'>
              <IconButton
                className='removeButton'
                iconProps={{ iconName: isCurrent ? 'SignOut' : 'Cancel' }}
                onClick={(event) => {
                  event.stopPropagation();
                  onRemoveAccountClick(account);
                }}
              />
            </TooltipHost>
          </div>)
      }
      )}
    </div>
  )
}
